import { render, staticRenderFns } from "./chantal.vue?vue&type=template&id=f8236ad0"
import script from "./chantal.vue?vue&type=script&lang=js"
export * from "./chantal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports